module.exports = __webpack_public_path__ + "img/icon_volunteers.855c15a.svg";